import React from 'react';
import {SITE_DATA, ENG_DISTANCE_DATA, DISTANCE_DETAILS, DISTANCE_DAILY_TASK} from "./type";

const initalState = {
    siteData: null,
    engDistanceData: {},
    distanceDetails: {},
    dailyDistance: {}
};

const leadDataReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SITE_DATA:
            return {
                ...state,
                siteData: payload,
            };
        case ENG_DISTANCE_DATA:
            return {
                ...state,
                engDistanceData: payload,
            };
        case DISTANCE_DETAILS:
            return {
                ...state,
                distanceDetails: payload,
            };
        case DISTANCE_DAILY_TASK:
            return {
                ...state,
                dailyDistance: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default leadDataReducer
